/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.less';
import { RightOutlined } from '@ant-design/icons';

export const DropdownButton = ( props ) => {
    const [ visible, setVisibility ] = useState( false );

    const updateVisibility = useCallback( ( enabled, executeCallbacks = true ) => {
        if ( visible !== enabled ) {
            // Execute the provided callbacks as needed.
            if ( executeCallbacks ) {
                if ( enabled && props.onShow ) {
                    props.onShow();
                } else if ( !enabled && props.onHide ) {
                    props.onHide();
                }

                if ( props.onToggle ) {
                    props.onToggle( enabled );
                }
            }

            // Update the state.
            setVisibility( enabled );
        }
    }, [ visible, setVisibility, props.onShow, props.onHide, props.onToggle ] );

    const handleToggle = useCallback( () => {
        updateVisibility( !visible );
    }, [ visible, updateVisibility ] );

    useEffect( () => {
        if ( props.getController ) {
            props.getController( {
                toggle: handleToggle,
                setVisibility: ( value ) => updateVisibility( value ),
            } );
        }
    }, [ updateVisibility, props.getController, handleToggle ] );

    useEffect( () => {
        if ( props.show !== undefined ) {
            updateVisibility( props.show );
        }
    }, [ updateVisibility, props.show ] );

    // Construct the classes to use for the component root.
    const rootClasses = classNames(
        'dropdown-button',
        { 'show': visible },
        { [ props.className ]: Boolean( props.className ) },
    );

    return (
        <button
            className={ rootClasses }
            style={ props.style }
            onClick={ ( props.interactable ) ? ( props.onClick ? props.onClick : handleToggle ) : undefined }
        >
            <div className="dropdown-button-content">
                { props.children }
            </div>
            <RightOutlined aria-label="" className="caret-icon" />
        </button>
    );
};

/**
 * The default properties used for this component if values aren't given
 * to the component externally.
 */
DropdownButton.defaultProps = {
    className: undefined,
    style: undefined,

    interactable: true,
    getController: undefined,
    show: undefined,
    onShow: undefined,
    onHide: undefined,
    onToggle: undefined,

    // Props to overwrite default behavior for more control.
    onClick: undefined,
};

/**
 * The type definitions of the properties this component accepts.
 */
DropdownButton.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,

    interactable: PropTypes.bool,
    getController: PropTypes.func,
    show: PropTypes.bool,
    onShow: PropTypes.func,
    onHide: PropTypes.func,
    onToggle: PropTypes.func,

    // Props to overwrite default behavior for more control.
    onClick: PropTypes.func,
};
